import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class EmployeeDocumentBus extends BaseBus
{
  CID(): any {
      return this.employeeDocumentId;
  }
    constructor(data: EmployeeDocumentBus = null) {
        super(data);
    }
    employeeDocumentId: any;
    attachmentDetailFullName: string;
    employeeId: string;
    note: string;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
}
